import { DocumentTemplate } from 'piramid-constants'
import { ReactNode } from 'react'

/**
 * Ancho del área de contenido de cada documento: A4 (210mm) menos los márgenes
 * laterales del preset con el que lo imprime la API
 * (`@piramid/internals/constants/pdf-presets`). Lo comparte cualquier vista
 * previa en el navegador. Las clases van literales porque Tailwind no genera
 * arbitrary values calculados.
 */
export const DOCUMENT_CONTENT_WIDTH_CLASS: Record<DocumentTemplate, string> = {
  sample: 'w-[172mm]',
  order_report: 'w-[172mm]',
  agreement: 'w-[182mm]',
}

/** Dev frame for `/preview`: as wide as the printed content area, so lines wrap as printed. */
export const DocumentPreviewFrame = ({
  template,
  children,
}: {
  template: DocumentTemplate
  children: ReactNode
}) => (
  <div className='min-h-screen bg-zinc-100 py-10'>
    <div
      className={`mx-auto ${DOCUMENT_CONTENT_WIDTH_CLASS[template]} bg-white shadow-sm`}
    >
      {children}
    </div>
  </div>
)
